<script setup>
import { route, Router } from '@/utils/ziggy.js'
import { ref } from 'vue'
/**
 * @import { Ref } from 'vue'
 */

const accountName = /** @type {HTMLInputElement | null} */ (document.getElementById('account-name'))?.value
const companyName = /** @type {HTMLInputElement | null} */ (document.getElementById('company-name'))?.value
const adminAccountName = /** @type {HTMLInputElement | null} */ (document.getElementById('admin-account-name'))?.value

const showScoutRequestSetting = ref(
  /** @type {HTMLInputElement | null} */
  (document.getElementById('show-scout-request-setting'))?.value === '1',
)

const enableScoutRequestSetting = ref(
  /** @type {HTMLInputElement | null} */
  (document.getElementById('enable-scout-request-setting'))?.value === '1',
)

const showApplyManagement = ref(
  /** @type {HTMLInputElement | null} */
  (document.getElementById('show-apply-management'))?.value === '1',
)

const showSchedule = ref(
  /** @type {HTMLInputElement | null} */
  (document.getElementById('show-schedule'))?.value === '1',
)

const showRecruitment = ref(
  /** @type {HTMLInputElement | null} */
  (document.getElementById('show-recruitment'))?.value === '1',
)

const showTemplate = ref(
  /** @type {HTMLInputElement | null} */
  (document.getElementById('show-template'))?.value === '1',
)

const showEffectivenessExport = ref(
  /** @type {HTMLInputElement | null} */
  (document.getElementById('show-effectiveness-export'))?.value === '1',
)

const showEffectivenessScout = ref(
  /** @type {HTMLInputElement | null} */
  (document.getElementById('show-effectiveness-scout'))?.value === '1',
)

const showEffectivenessScoutRequest = ref(
  /** @type {HTMLInputElement | null} */
  (document.getElementById('show-effectiveness-scout-request'))?.value === '1',
)

const showEffectivenessRecruitment = ref(
  /** @type {HTMLInputElement | null} */
  (document.getElementById('show-effectiveness-recruitment'))?.value === '1',
)

const showSettingStandard = ref(
  /** @type {HTMLInputElement | null} */
  (document.getElementById('show-setting-standard'))?.value === '1',
)
const showSettingCompany = ref(
  /** @type {HTMLInputElement | null} */
  (document.getElementById('show-setting-company'))?.value === '1',
)
const showSettingAccount = ref(
  /** @type {HTMLInputElement | null} */
  (document.getElementById('show-setting-account'))?.value === '1',
)
const showSettingPhaseTag = ref(
  /** @type {HTMLInputElement | null} */
  (document.getElementById('show-setting-phase-tag'))?.value === '1',
)
const showCoverScout = ref(
  /** @type {HTMLInputElement | null} */
  (document.getElementById('show-cover-scout'))?.value === '1',
)

const showCoverScoutPermission = ref(
  /** @type {HTMLInputElement | null} */
  (document.getElementById('show-cover-scout-permission'))?.value === '1',
)

const showActiveScout = ref(
  /** @type {HTMLInputElement | null} */
  (document.getElementById('show-active-scout'))?.value === '1',
)

const showActiveScoutPermission = ref(
  /** @type {HTMLInputElement | null} */
  (document.getElementById('show-active-scout-permission'))?.value === '1',
)

const _unreadMessageCount =
  /** @type {HTMLInputElement | null} */ (document.getElementById('unread-message-count'))?.value ?? 0
const unreadMessageCount = ref(Number(_unreadMessageCount))
const _unreadScoutRequestCount =
  /** @type {HTMLInputElement | null} */ (document.getElementById('unread-scout-request-count'))?.value ?? 0
const unreadScoutRequestCount = ref(Number(_unreadScoutRequestCount))
const _recruitmentCount =
  /** @type {HTMLInputElement | null} */ (document.getElementById('recruitment-count'))?.value ?? 0
const recruitmentCount = ref(Number(_recruitmentCount))

const FAQLink = /** @type {HTMLInputElement | null} */ (document.getElementById('faq-link'))?.value ?? ''

/**
 * @typedef {'scout' | 'scout_request' | 'template_management' | 'effectiveness_measurement' | 'settings' | 'account'} AccordionList
 */

/** @type {Ref<AccordionList | undefined>} */
const openedAccordion = ref()

const routes = /** @satisfies {{[key: AccordionList]: Record<string, string>}} */ ({
  scout: {
    student_search: 'company.scout.student_search.*',
    saved_search_condition: 'company.scout.saved_search_condition.list',
    cover_scout: 'company.scout.cover_scout',
    active_scout_x: 'company.scout.active_scout_x',
    save_list: 'company.scout.save_list',
    sent_scout: 'company.scout.sent_search.*',
    reservation_list: 'company.scout.reservation_list',
    reservation_list_search: 'company.scout.reservation_list.search',
  },
  scout_request: {
    scout_request_list: 'company.scout_request.list',
    scout_request_setting: 'company.scout_request.setting',
  },
  apply_management: {
    apply_management: 'company.apply_management.list',
  },
  recruitment: {
    recruitment: 'company.recruit.list',
  },
  schedule: {
    schedule: 'company.schedule.list',
  },
  template_management: {
    template: 'company.template.list',
    scout_auto_reply_template: 'company.scout_auto_reply_template.list',
    scout_other_schedule_auto_reply_template: 'company.scout_other_schedule_auto_reply_template.edit',
  },
  effectiveness_measurement: {
    effectiveness_measurement_scout: 'effectiveness_measurement.scout.cumulative_total',
    effectiveness_measurement_scout_request: 'effectiveness_measurement.scout_request.monthly_total',
    effectiveness_measurement_recruitment: 'effectiveness_measurement.recruitment.monthly_total',
    effectiveness_measurement_export: 'company.effectiveness_measurement.detaildata',
  },
  settings: {
    setting_standard: 'company.setting.standard',
    setting_company: 'company.setting.company',
    setting_account: 'company.setting.account.list',
    setting_phase_tag: 'company.setting.phase.tag',
  },
})

/** @type {string} */
let openedPage
for (const [groupKey, routeKeys] of Object.entries(routes)) {
  for (const [key, value] of Object.entries(routeKeys)) {
    // @ts-expect-error: strictRouteNames が true なので、currentには実在するルートネームしか渡せない
    if (Router().current(value)) {
      openedAccordion.value = /** @type {AccordionList} */ (groupKey)
      openedPage = key
    }
  }
}

/**
 * @param {AccordionList} type
 */
const toggleAccordion = type => {
  if (openedAccordion.value === type) {
    openedAccordion.value = undefined
  } else {
    openedAccordion.value = type
  }
}
</script>

<template>
  <div class="logoArea">
    <a
      href=""
      class=""
    >
      <div class="imgCell">
        <img
          src="/company_site/imageFile/logo_white.svg"
          alt=""
        />
      </div>
    </a>
  </div>
  <div class="menuArea">
    <div class="menuList">
      <div class="accountSet">
        <div class="companyName">{{ companyName }}</div>
        <div
          v-if="accountName !== ''"
          class="accountName"
        >
          {{ accountName }}
        </div>
        <div
          v-if="adminAccountName !== ''"
          class="accountName"
        >
          {{ adminAccountName }}
        </div>
      </div>
      <div class="mainMenuArea">
        <div
          href=""
          class="menuCell"
        >
          <a
            :href="route('company.scout.student_search.form')"
            class="mainMenu mainMenu--directLink"
          >
            <span class="iconImgPart">
              <svg
                style="width: 22px"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 -3 20 20"
              >
                <path
                  fill="#fff"
                  stroke="#fff"
                  stroke-width=".3"
                  d="M8.665 1h-.33c-.398 0-.788.138-1.096.387L1.635 5.93A1.7 1.7 0 0 0 1 7.256v8.03C1 16.23 1.777 17 2.73 17h11.54c.953 0 1.73-.77 1.73-1.714v-8.03c0-.516-.23-1-.635-1.327L9.76 1.387A1.746 1.746 0 0 0 8.665 1Zm2.143 14.857H6.191v-5.143c0-.315.258-.571.577-.571h3.462c.318 0 .576.256.576.571v5.143Zm4.038-8.601v8.03a.574.574 0 0 1-.577.571h-2.308v-5.143c0-.945-.776-1.714-1.73-1.714H6.769c-.954 0-1.73.77-1.73 1.714v5.143H2.73a.574.574 0 0 1-.577-.571v-8.03c0-.172.077-.333.211-.442l5.604-4.542a.58.58 0 0 1 .366-.13h.33c.133 0 .262.047.366.13l5.603 4.542c.135.109.212.27.212.442Z"
                />
              </svg> </span
            >ホーム
          </a>
        </div>
        <div class="menuCell">
          <div
            class="mainMenu js_menuOpen js_navi_scout"
            :class="{ open: openedAccordion === 'scout' }"
            @click="toggleAccordion('scout')"
          >
            <span class="iconImgPart">
              <svg
                style="width: 22px"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 -2 20 20"
              >
                <path
                  fill="#fff"
                  fill-rule="evenodd"
                  d="M.213 2.759C-.301 1.46 1.041.205 2.303.802l12.125 5.744c1.173.556 1.173 2.225 0 2.78L2.302 15.07c-1.261.598-2.603-.658-2.089-1.956l2.035-5.14.014-.038-.014-.037L.213 2.76Zm1.473-.657-.229-.108.093.235L3.5 7.154l.025.063H12.04l.043-.19L1.685 2.102Zm1.907 6.554h-.068l-.025.063-1.95 4.924-.093.236.23-.108 10.396-4.925-.043-.19H3.593Z"
                  clip-rule="evenodd"
                />
              </svg> </span
            >スカウト
          </div>
          <div
            class="menuInner"
            :class="{ open: openedAccordion === 'scout' }"
          >
            <div class="menuInnerWrap">
              <a
                :href="route('company.scout.student_search.form')"
                class="subMenu"
                :class="{
                  selected: openedPage === 'student_search',
                }"
                >学生検索</a
              >
              <a
                :href="route('company.scout.saved_search_condition.list')"
                class="subMenu"
                :class="{
                  selected: openedPage === 'saved_search_condition',
                }"
                >保存済み検索条件</a
              >
              <a
                :href="route('company.scout.cover_scout')"
                class="subMenu"
                :class="{
                  selected: openedPage === 'cover_scout',
                }"
                v-if="showCoverScout && showCoverScoutPermission"
                >カバースカウト</a
              >
              <a
                :href="route('company.scout.active_scout_x')"
                v-if="showActiveScout && showActiveScoutPermission"
                class="subMenu"
                :class="{
                  selected: openedPage === 'active_scout_x',
                }"
                >アクティブスカウトX</a
              >
              <a
                :href="route('company.scout.save_list')"
                class="subMenu"
                :class="{
                  selected: openedPage === 'save_list',
                }"
                >保存済み学生リスト</a
              >
              <a
                :href="route('company.scout.reservation_list')"
                class="subMenu"
                :class="{
                  selected: openedPage === 'reservation_list' || openedPage === 'reservation_list_search',
                }"
                >スカウト予約</a
              >
              <a
                :href="route('company.scout.sent_search.form')"
                class="subMenu"
                :class="{
                  selected: openedPage === 'sent_scout',
                }"
                >スカウト済み</a
              >
            </div>
          </div>
        </div>
        <div class="menuCell">
          <div
            class="mainMenu js_menuOpen js_navi_request"
            :class="{ open: openedAccordion === 'scout_request' }"
            @click="toggleAccordion('scout_request')"
          >
            <span class="iconImgPart">
              <svg
                style="width: 20px"
                viewBox="0 0 19 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.05717 4.04959L7.80663 2.79906C6.42533 1.41776 4.18579 1.41772 2.8045 2.79901C1.42322 4.18029 1.42322 6.41979 2.80449 7.80109L9.05709 14.0538L15.2943 7.81655L15.3098 7.80118C16.6911 6.41989 16.6911 4.18037 15.3098 2.79907C13.9285 1.41777 11.689 1.41776 10.3077 2.79904L9.05717 4.04959ZM1.5539 9.05165C-0.518005 6.9797 -0.517951 3.6204 1.55397 1.54848C3.6259 -0.523456 6.98518 -0.523441 9.05713 1.54851C11.1291 -0.523423 14.4884 -0.523409 16.5603 1.54854C18.6323 3.62049 18.6323 6.97978 16.5604 9.05171L16.5373 9.07467L9.99499 15.617C9.47701 16.1349 8.63719 16.1349 8.1192 15.6169L1.5539 9.05165Z"
                />
              </svg> </span
            >スカウトリクエスト
            <em
              v-if="openedAccordion !== 'scout_request' && unreadScoutRequestCount > 0"
              class="md_numBadge"
              >{{ unreadScoutRequestCount >= 100 ? '+99' : unreadScoutRequestCount }}</em
            >
          </div>
          <div
            class="menuInner"
            :class="{ open: openedAccordion === 'scout_request' }"
          >
            <div class="menuInnerWrap">
              <a
                :href="route('company.scout_request.list')"
                class="subMenu"
                :class="{ selected: openedPage === 'scout_request_list' }"
                >リクエスト一覧
                <em
                  v-if="unreadScoutRequestCount > 0"
                  class="md_numBadge"
                  >{{ unreadScoutRequestCount >= 100 ? '+99' : unreadScoutRequestCount }}</em
                >
              </a>
              <a
                :href="enableScoutRequestSetting ? route('company.scout_request.setting') : 'javascript:void(0)'"
                v-if="showScoutRequestSetting"
                class="subMenu"
                :class="{ selected: openedPage === 'scout_request_setting', disabled: !enableScoutRequestSetting }"
                >設定</a
              >
            </div>
          </div>
        </div>
        <div
          v-if="showApplyManagement"
          class="menuCell"
        >
          <a
            :href="route('company.apply_management.list')"
            class="mainMenu mainMenu--directLink"
            :class="{ selected: openedPage === 'apply_management' }"
          >
            <div class="iconImgPart">
              <svg
                style="width: 20px"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.59031 4.16388C9.59031 6.07064 8.04457 7.61639 6.1378 7.61639C4.23103 7.61639 2.68529 6.07064 2.68529 4.16388C2.68529 2.25711 4.23103 0.711365 6.1378 0.711365C8.04457 0.711365 9.59031 2.25711 9.59031 4.16388ZM8.05586 4.16388C8.05586 5.22319 7.19711 6.08194 6.1378 6.08194C5.07848 6.08194 4.21974 5.22319 4.21974 4.16388C4.21974 3.10456 5.07848 2.24581 6.1378 2.24581C7.19711 2.24581 8.05586 3.10456 8.05586 4.16388Z"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M0 13.6952C0 10.7617 2.37806 8.38361 5.31155 8.38361H6.96404C9.89753 8.38361 12.2756 10.7617 12.2756 13.6952C12.2756 14.5752 11.5622 15.2886 10.6821 15.2886H1.59347C0.713419 15.2886 0 14.5752 0 13.6952ZM1.53445 13.6952C1.53445 11.6091 3.22552 9.91806 5.31155 9.91806H6.96404C9.05008 9.91806 10.7411 11.6091 10.7411 13.6952C10.7411 13.7278 10.7147 13.7542 10.6821 13.7542H1.59347C1.56087 13.7542 1.53445 13.7278 1.53445 13.6952Z"
                />
                <path
                  d="M12.9813 14.596C12.9019 14.9036 13.1022 15.2886 13.4198 15.2886H13.751C14.6311 15.2886 15.3445 14.5752 15.3445 13.6952C15.3445 10.7617 12.9664 8.38361 10.0329 8.38361C9.92379 8.38361 9.88404 8.53515 9.97671 8.59283C10.7023 9.04446 11.3323 9.63529 11.8292 10.328C11.8629 10.3749 11.9063 10.4141 11.9561 10.4436C13.0659 11.1015 13.81 12.3114 13.81 13.6952C13.81 13.7278 13.7836 13.7542 13.751 13.7542H13.3876C13.1951 13.7542 13.0428 13.9158 13.0428 14.1083C13.0428 14.2767 13.0214 14.4402 12.9813 14.596Z"
                />
                <path
                  d="M9.91175 6.05361C9.95396 5.96947 10.0234 5.90241 10.1065 5.85819C10.7123 5.53578 11.1248 4.89799 11.1248 4.16388C11.1248 3.42976 10.7123 2.79197 10.1065 2.46956C10.0234 2.42534 9.95396 2.35828 9.91175 2.27414C9.69739 1.84687 9.41259 1.46104 9.07261 1.13188C8.91745 0.981666 8.99074 0.711365 9.20669 0.711365C11.1135 0.711365 12.6592 2.25711 12.6592 4.16388C12.6592 6.07064 11.1135 7.61639 9.20669 7.61639C8.99074 7.61639 8.91745 7.34608 9.07261 7.19587C9.41259 6.86671 9.69739 6.48088 9.91175 6.05361Z"
                />
              </svg>
            </div>
            応募者管理
            <em
              v-if="unreadMessageCount > 0"
              class="md_numBadge"
              >{{ unreadMessageCount >= 100 ? '+99' : unreadMessageCount }}</em
            >
          </a>
        </div>
        <div
          v-if="showRecruitment"
          class="menuCell"
        >
          <a
            :href="route('company.recruit.list')"
            class="mainMenu mainMenu--directLink"
            :class="{ selected: openedPage === 'recruitment' }"
          >
            <span class="iconImgPart">
              <svg
                style="width: 16px"
                viewBox="0 0 15 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.1897 19.5833C0.532406 19.5815 0.00179261 19.0479 0 18.389V1.60916C0.00179261 0.95212 0.532406 0.418465 1.1897 0.416668H10.7933C10.9672 0.416668 11.1238 0.493332 11.2283 0.614917L11.2379 0.6245L14.8434 4.1846C14.9408 4.28761 15 4.42777 15 4.58349V18.3777C14.9982 19.0365 14.4676 19.572 13.8121 19.5791L1.1891 19.5827L1.1897 19.5833ZM1.1652 18.4136H13.8366V5.16925H11.3771C10.7294 5.16746 10.2048 4.64698 10.1934 3.99952V3.99773L10.2065 1.5852H1.1652V18.4136ZM11.3568 4.00551H13L11.364 2.39017L11.3568 4.00551ZM2.7917 17.0265C2.6202 17.0229 2.48158 16.8821 2.47978 16.7102V16.1448C2.47978 16.1448 2.47978 16.1448 2.47978 16.143C2.47978 15.9687 2.61781 15.8286 2.78991 15.8232H8.90511C9.07899 15.8286 9.21703 15.9693 9.21703 16.1454V16.7048C9.21703 16.8791 9.0772 17.0211 8.90332 17.0271L2.7917 17.0265ZM12.1713 14.56C12.1599 14.56 12.1509 14.56 12.1396 14.5582H2.8646C2.85504 14.5582 2.84428 14.56 2.83472 14.56C2.6459 14.56 2.48934 14.4139 2.47261 14.2306V13.6862C2.49114 13.4987 2.6465 13.355 2.83472 13.3532C2.84607 13.3532 2.85504 13.3532 2.86639 13.355H12.1414C12.1509 13.355 12.1617 13.3532 12.1713 13.3532C12.3601 13.3532 12.5148 13.4975 12.5334 13.6826V14.227C12.5148 14.4145 12.3595 14.5582 12.1713 14.56ZM10.427 12.6338L10.3972 12.5458C10.2549 12.4709 10.1414 12.3475 10.0757 12.196L10.053 12.1493V12.1379C9.53014 10.8915 8.54061 10.1201 7.46325 10.1201C6.42473 10.1201 5.45015 10.8556 4.91595 12.0403C4.80002 12.2984 4.54428 12.4649 4.26224 12.4649C3.86667 12.4649 3.5434 12.1409 3.5434 11.7444C3.5434 11.6378 3.56551 11.5348 3.60853 11.4431C4.37577 9.73976 5.85289 8.68024 7.46265 8.68024C8.3494 8.68742 9.17878 8.9851 9.86237 9.53912C10.54 10.0895 11.0646 10.8047 11.3861 11.6037L11.3879 11.6108L11.401 11.6486C11.4327 11.7306 11.4512 11.8229 11.4512 11.9145C11.4512 12.3092 11.1297 12.6332 10.736 12.635H10.4258L10.427 12.6338ZM7.22663 8.39275V8.37598C6.60698 8.31069 6.03334 8.03518 5.59296 7.58418C5.0964 7.07867 4.82572 6.40846 4.82572 5.70111V5.62445C4.82572 4.9171 5.0982 4.24868 5.59296 3.74138C6.08593 3.23588 6.7468 2.94958 7.45309 2.93461H7.47162C8.17731 2.95138 8.83819 3.23588 9.33175 3.74138C9.82831 4.24689 10.099 4.9165 10.099 5.62445V5.70111C10.099 6.40846 9.82651 7.07688 9.33175 7.58418C8.83878 8.08968 8.17791 8.37598 7.47162 8.39095H7.22722L7.22663 8.39275ZM7.46385 4.37027C6.78983 4.39662 6.261 4.94465 6.261 5.62085V5.69932C6.261 6.37492 6.78923 6.92355 7.46325 6.9499C8.13727 6.92355 8.6637 6.37552 8.6637 5.69932V5.62085C8.6637 4.94525 8.13727 4.39662 7.46325 4.37027H7.46385Z"
                  fill="white"
                />
              </svg> </span
            >募集情報
            <em
              v-if="recruitmentCount > 0"
              class="md_numBadge"
              >{{ recruitmentCount >= 100 ? '+99' : recruitmentCount }}</em
            >
          </a>
        </div>
        <div
          v-if="showSchedule"
          class="menuCell"
        >
          <a
            :href="route('company.schedule.list')"
            class="mainMenu mainMenu--directLink"
            :class="{ selected: openedPage === 'schedule' }"
          >
            <span class="iconImgPart">
              <svg
                style="width: 18px"
                viewBox="0 0 15 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M4.75939 0.860911C4.75939 0.422821 4.40425 0.0676785 3.96616 0.0676785C3.52807 0.0676785 3.17293 0.422821 3.17293 0.860911H2.3797C1.06543 0.860911 0 1.92634 0 3.24061V13.5526C0 14.8669 1.06543 15.9323 2.3797 15.9323H11.8985C13.2128 15.9323 14.2782 14.8669 14.2782 13.5526V3.24061C14.2782 1.92634 13.2128 0.860911 11.8985 0.860911H11.1053C11.1053 0.422821 10.7501 0.0676785 10.312 0.0676785C9.87393 0.0676785 9.51879 0.422821 9.51879 0.860911H4.75939ZM12.6917 4.03384V3.24061C12.6917 2.80252 12.3366 2.44738 11.8985 2.44738H11.1053C11.1053 2.88547 10.7501 3.24061 10.312 3.24061C9.87393 3.24061 9.51879 2.88547 9.51879 2.44738H4.75939C4.75939 2.88547 4.40425 3.24061 3.96616 3.24061C3.52807 3.24061 3.17293 2.88547 3.17293 2.44738H2.3797C1.94161 2.44738 1.58646 2.80252 1.58646 3.24061V4.03384H12.6917ZM1.58646 5.6203V13.5526C1.58646 13.9907 1.94161 14.3459 2.3797 14.3459H11.8985C12.3366 14.3459 12.6917 13.9907 12.6917 13.5526V5.6203H1.58646Z"
                  fill="white"
                />
              </svg> </span
            >日程調整
          </a>
        </div>
      </div>
      <div class="subMenuArea">
        <div
          class="menuCell"
          v-if="showTemplate"
        >
          <div
            class="mainMenu js_menuOpen js_navi_template"
            :class="{ open: openedAccordion === 'template_management' }"
            @click="toggleAccordion('template_management')"
          >
            テンプレート管理
          </div>
          <div
            class="menuInner"
            :class="{ open: openedAccordion === 'template_management' }"
          >
            <div class="menuInnerWrap">
              <a
                :href="route('company.template.list')"
                class="subMenu"
                :class="{ selected: openedPage === 'template' }"
                >スカウト</a
              >
              <a
                :href="route('company.scout_auto_reply_template.list')"
                class="subMenu"
                :class="{ selected: openedPage === 'scout_auto_reply_template' }"
                >スカウトオートリプライ</a
              >
              <a
                :href="route('company.scout_other_schedule_auto_reply_template.edit')"
                class="subMenu"
                :class="{ selected: openedPage === 'scout_other_schedule_auto_reply_template' }"
                >スカウト別日程オートリプライ</a
              >
            </div>
          </div>
        </div>
        <div class="menuCell">
          <div
            class="mainMenu js_menuOpen js_navi_impact"
            :class="{ open: openedAccordion === 'effectiveness_measurement' }"
            @click="toggleAccordion('effectiveness_measurement')"
          >
            効果測定
          </div>
          <div
            class="menuInner"
            :class="{ open: openedAccordion === 'effectiveness_measurement' }"
          >
            <div class="menuInnerWrap">
              <a
                v-if="showEffectivenessScout"
                :href="route('effectiveness_measurement.scout.cumulative_total')"
                class="subMenu"
                :class="{ selected: openedPage === 'effectiveness_measurement_scout' }"
                >スカウト</a
              >
              <a
                v-if="showEffectivenessScoutRequest"
                :href="route('effectiveness_measurement.scout_request.monthly_total')"
                class="subMenu"
                :class="{ selected: openedPage === 'effectiveness_measurement_scout_request' }"
                >スカウトリクエスト</a
              >
              <a
                v-if="showEffectivenessRecruitment"
                :href="route('effectiveness_measurement.recruitment.monthly_total')"
                class="subMenu"
                :class="{ selected: openedPage === 'effectiveness_measurement_recruitment' }"
                >募集情報</a
              >
              <a
                v-if="showEffectivenessExport"
                :href="route('company.effectiveness_measurement.detaildata')"
                class="subMenu"
                :class="{ selected: openedPage === 'effectiveness_measurement_export' }"
                >エクスポート</a
              >
            </div>
          </div>
        </div>
        <div class="menuCell">
          <div
            class="mainMenu js_menuOpen js_navi_setting"
            :class="{ open: openedAccordion === 'settings' }"
            @click="toggleAccordion('settings')"
          >
            設定
          </div>
          <div
            class="menuInner"
            :class="{ open: openedAccordion === 'settings' }"
          >
            <div class="menuInnerWrap">
              <a
                v-if="showSettingStandard"
                :href="route('company.setting.standard')"
                :class="{ selected: openedPage === 'setting_standard' }"
                class="subMenu"
                >基本設定</a
              >
              <a
                v-if="showSettingCompany"
                :href="route('company.setting.company')"
                :class="{ selected: openedPage === 'setting_company' }"
                class="subMenu"
                >企業情報</a
              >
              <a
                v-if="showSettingAccount"
                :href="route('company.setting.account.list')"
                :class="{ selected: openedPage === 'setting_account' }"
                class="subMenu"
                >担当者管理</a
              >
              <a
                v-if="showSettingPhaseTag"
                :href="route('company.setting.phase.tag')"
                :class="{ selected: openedPage === 'setting_phase_tag' }"
                class="subMenu"
                >フェーズ/タグ</a
              >
            </div>
          </div>
        </div>
        <a
          :href="FAQLink"
          class="mainMenu menuLink"
          target="_blank"
          >FAQ</a
        >
        <a
          href="https://en-hyouban.com/"
          class="mainMenu menuLink"
          target="_blank"
          >エン カイシャの評判</a
        >
        <a
          :href="route('company.logout')"
          class="mainMenu menuLink"
          >ログアウト</a
        >
      </div>
    </div>
  </div>
</template>
